import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Box, Grid, IconButton } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { Page, toggleSidebar } from 'features/document/documentSlice';
import { FC, MutableRefObject, RefObject, useState, useEffect } from 'react';
import { Page as ReactPdf, pdfjs } from 'react-pdf';
import styles from './ViewerThumbnailBar.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface Props {
  currentPage: number;
  pages: Page[];
  thumbnailPagesRef: MutableRefObject<RefObject<HTMLDivElement>[]>;
  scrollToPage: (pageIndex: number, fromThumbnail: boolean) => void;
}

const ViewerThumbnailSidebar: FC<Props> = ({ currentPage, pages, thumbnailPagesRef, scrollToPage }) => {
  const selector = useAppSelector;
  const dispatch = useAppDispatch();
  const isSidebarOpen = selector(state => state.document.isSidebarOpen);
  const [selectedThumbnail, setSelectedThumbnail] = useState(-1);

  useEffect(() => {
    setSelectedThumbnail(currentPage - 1);
  }, [currentPage]);

  const handleCloseSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleThumbnailClick = (pageIndex: number) => {
    setSelectedThumbnail(pageIndex);
    scrollToPage(pageIndex, true);
  };

  return (
    <Grid item xs={2} className={`${styles.sidebar} ${isSidebarOpen ? styles.sidebarOpen : styles.sidebarClosed}`}>
      <div className={styles.sidebarTitle}>
        <p>
          <strong>Page Thumbnails</strong>
        </p>
        <IconButton onClick={handleCloseSidebar}>
          <CloseRounded color='primary' />
        </IconButton>
      </div>
      <Box
        className={styles.sidebarContent}
        sx={{
          overflowY: 'auto',
        }}
      >
        {[...Array(pages.length)].map((_, index) => (
          <Grid
            className={`${styles.thumbnail} ${index === selectedThumbnail && styles.selectedThumbnail}`}
            item
            container
            key={`page-${index}`}
            ref={thumbnailPagesRef.current[index]}
            onClick={() => handleThumbnailClick(index)}
          >
            <Box
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 10,
              }}
            />
            <Grid item xs={3} className={styles.thumbnailIndex}>
              {index + 1}
            </Grid>
            <Grid className={styles.thumbnailContainer} item xs={9}>
              <ReactPdf
                className={styles.page}
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                height={1054}
                width={816}
                scale={0.1}
              />
            </Grid>
          </Grid>
        ))}
      </Box>
    </Grid>
  );
};

export default ViewerThumbnailSidebar;
